import { h } from 'preact';

import { NEUTRAL, TIE } from '../utils/primary-colors';

const ResultMapLegend = ({ candidates, colorMap, includesTie }) => {
  return (
    <div class="results-map__legend">
      <p class="results-map__legend-title">Current leader</p>
      <div class="results-map__legend-items">
        {candidates.map((candidate, idx) => (
          <div class="results-map__legend-item">
            <span
              class="pill-circle"
              style={{ backgroundColor: colorMap.get(candidate.id) || NEUTRAL }}
            />{' '}
            <p class="results-map__legend-label">
              {candidate.ballot_sort_name}
            </p>
          </div>
        ))}
        {includesTie && (
          <div class="results-map__legend-item">
            <span class="pill-circle" style={{ backgroundColor: TIE }} />{' '}
            <p class="results-map__legend-label">Tied</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultMapLegend;



// WEBPACK FOOTER //
// ./componentsV2/ResultsMapLegend.js